// extracted by mini-css-extract-plugin
export default {"root":"EditListingRulesPanel_root__LxcUu","form":"EditListingRulesPanel_form__D+X6R"};